// Source/Product-Card-Buy-More/Component.ts
class ProductCardBuyMore extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    this.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();
      this.quickView.click();
    }, { signal });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  get quickView() {
    return this.card.querySelector(`.boost-sd__button--quick-view`);
  }
  get card() {
    return this.closest(`.Boost-Search-Card`);
  }
}

// Source/Product-Card-Buy-More/mod.ts
customElements.define("product-card-buy-more", ProductCardBuyMore);
